<template>
    <div class="phonebox">
        <div class="pic">
            <ul>
                <li class="imgbox f-row-c pinter" :style="actStr(item,ind)" :class="act==ind?'actbox':''" v-for="(item,ind) in bannerS" :key='ind' @mouseenter="onhover(ind)" @click="goDetail(item,ind)">
                    <el-image fit='cover' class="w-100 img" :src="$fileAccessHttpUrl(item.breviaryMap)"></el-image>
                    <div class="txt-w100 f-row-c">
                        <p class="p1 f-row-l overfh">{{item.pictureTitle||''}}</p>
                    </div>
                </li>

            </ul>
        </div>
    </div>
</template>

<script>
export default {
    computed:{

    },
    name: 'phoneBooks',
    props:['is_index'],
    data() {
        return {
            act:0,
            bannerS:[
                // {breviaryMap:require('./../../assets/sfq_img/a1.png'),pictureTitle:'雨红了枫叶 ，枫叶红了山头 ，山头红了整个秋'},
                // {breviaryMap:require('./../../assets/sfq_img/a2.png'),pictureTitle:'莫愁前路无知己 ,天下谁人不识君 。'},
                // {breviaryMap:require('./../../assets/sfq_img/a3.png'),pictureTitle:'你能看到多远的过去 ，就能看到多远的未来。'},
                // {breviaryMap:require('./../../assets/sfq_img/a4.png'),pictureTitle:'编不下去了 。 。 。 。  。'},
            ],
            phones:[],
            param:{
                pageNo:1,//分页
                pageSize:4,
                total: 0,
                // isTop:0,
            },
            page:false,
        };
    },

    mounted() {

        this.page=false
        this.getList()
        this.onhover(0)
    },

    methods: {
        goDetail(item,ind){
            if(this.act==ind){
                this.$util.goPage('phoneBooksDetail', 7, item.id)
            }
        },
        onhover(ind){
            this.act=ind
            // this.$refs.imgbox[ind].stop(true).animate({width:"800px"},1000).siblings().stop(true).animate({width:"100px"},1000);

            // $(".pic ul li").hover(function(e){
            //     $(this).stop(true).animate({width:"800px"},1000).siblings().stop(true).animate({width:"100px"},1000);

            // });
        },
        actStr(item,ind){//background-image:${item.breviaryMap};
            var str=`width:${this.act==ind?'calc(100% - '+(this.bannerS.length-1)*100+'px)':'100px'}`
            return str
        },
        onLeft(){
            this.page=false;
            if(this.param.pageNo>1){
                this.param.pageNo--
                this.getList()
            }
        },
        onRight(){
            if(!this.page){
                this.param.pageNo++
                this.getList()
            }else{
                 this.$message({
                    message: '没有更多了',
                    type: 'warning'
                });
            }

        },
        getList(){
            this.$get('/web/home/getLasBatchList',this.param).then(res=>{
               this.bannerS=this.phones=res.result.records;
               this.param.total= res.result.total
               this.$emit('phoneLen',this.phones.length);
               if(this.phones.length<this.param.pageSize){
                   this.page=true
               }
            })
        }
    },
};
</script>

<style lang="scss" scoped>
* {
    margin: 0px;
    padding: 0px;
    font-family: "微软雅黑";
    list-style: none;
}

.phonebox {
    width: 100%;
    height: 444px;
    background-color: #2A2A2A
}
.pic {
    overflow: hidden;
    height: 444px;
    margin: 0 auto;
}
.pic ul .imgbox {
    float: left;
    height: 100%;
    width: 100px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    .img{
        width: 100%;
        height:444px;
    }
}

.txt-w100{
    background-color: #000;
    background: rgba(0, 0, 0, .5);
    height: 444px;
    width: 100px;
    position: absolute;
    z-index: 2;
    left: 0px;
    bottom: 0px;
    color: #fff;
    transition:height 1s;
}
.p1{
    text-decoration: none;
    position: absolute;
    bottom: 0px;
    font-size: 18px;
    width: 28px;
    height: 100%;
    padding:10px;
    box-sizing: border-box;
    z-index: 3;
    align-items: flex-start;
    overflow: hidden;
}

.actbox .txt-w100 {
    width: 100%;
    height: 70px;
    line-height: 70px;
    transition:height 1s;

    .p1{
        width: 100%!important;
        font-size: 24px;
        padding:0px 10px;
    }
}
.pic ul .actbox{
    height: 100%;
    .img{
        width: 100%!important;
        height:444px!important;
        // transform: width 0.5s;
    }
}
</style>
